export class CRouteParamsError extends Error {
  constructor(routeParam: number | string) {
    super(`Invalid route param ${routeParam}.`);
  }
}
